import { SavedPersona } from '../../../domain/chat/models/SavedPersona';
import { SavedPrompt } from '../../../domain/chat/models/SavedPrompt';

export interface ChatPersonalizationState {
    userId: string | null;
    personas: SavedPersona[];
    prompts: SavedPrompt[];
    isLoaded: boolean;
}

export const initialChatPersonalizationState: ChatPersonalizationState = {
    userId: null,
    personas: [],
    prompts: [],
    isLoaded: false,
};

